/**
 * Whether the "Active Until" (validToMoment) field is required.
 *
 * Required on create and single-card update. Optional on bulk update, where a
 * blank value means "leave each selected card's date unchanged". Recurring forms
 * hide the field entirely, so it is never required there.
 *
 * Keyed on the card type (isBulkUpdate), NOT isUpdateForm — gating on
 * isUpdateForm would wrongly make single-card updates optional too.
 */
export const validToIsRequired = (
  recurrenceEditable: boolean,
  isBulkUpdate: boolean,
): boolean => !recurrenceEditable && !isBulkUpdate
